import { asyncFrame } from '@utils/asyncFrame';
import { type ParsedDataProps, type XDomain, calibrateData, percentifyData } from '@widgets/performanceOverview';

export const dateFormats = {
  en: 'YYYY-MM-DD',
  de: 'DD.MM.YYYY',
};

export const cutDataToXDomain = async (data: ParsedDataProps[], xDomain: XDomain): Promise<ParsedDataProps[]> => {
  const cutData = await asyncFrame(() => data.filter((d) => d.date.valueOf() >= xDomain[0].valueOf() && d.date.valueOf() <= xDomain[1].valueOf()));

  const sortedData = await asyncFrame(() => {
    cutData.sort((da, db) => da.date.valueOf() - db.date.valueOf());
    return cutData;
  });

  return sortedData;
};

export const dataProcessingPipeline = async (parsedData: ParsedDataProps[], xDomain: XDomain, hasBenchmark: boolean): Promise<any> => {
  const cutData = await asyncFrame(() => cutDataToXDomain(parsedData, xDomain));
  const percentifiedData = await asyncFrame(() => percentifyData(cutData, hasBenchmark));
  const calibratedData = await asyncFrame(() => calibrateData(percentifiedData[0], percentifiedData));

  return calibratedData;
};

export const formatExcelTableData = (data) =>
  data.map((dataPoint) => ({
    date: dataPoint.date,
    performance: (dataPoint.performance - 100) / 100,
    benchnmark: (dataPoint.benchmark - 100) / 100,
  }));
